
const Proyects = ({producto}) => {
    const { nombre, url, urlImagen, descripcion }= producto
    return ( 
    <>
     <div className="row mx-auto row-cols-1 row-cols-md-3 g-4 ">
        <div className="col-md-12 mt-3 ">
            <div className="card h-100 p-2"  width="100%">
                <div className="view overlay zoom z-depth-1-half ">
                    <img    src={urlImagen} className="img-fluid rounded h-100 w-100" alt="mmmm" />
                        <div className="mask rgba-white-slight" />
                    </div>
                <h4 className="my-4 font-weight-bold display-5 text-center">{nombre} </h4>
                <p className="m-auto text-center">{descripcion} </p>
            <a  target="_blank" rel="noopener noreferrer" href={url} className="button btn text_b ">
                     Visit the page
            </a>
            </div>
        </div>
   
  
</div>

    </> );
}
 
export default Proyects;

/**
 * className="col-lg-4 col-md-6 mb-4"
  <div className="view overlay zoom z-depth-1-half ">
                        <img    src="https://mdbootstrap.com/img/new/standard/city/041.jpg" className="img-fluid rounded" alt="mmmm" />
                        <div className="mask rgba-white-slight" />
                    </div>
                    <h4 className="my-4 font-weight-bold letracontnent">Desayuno</h4>
                    <p className="letracontnent">Para que empieces el día saludable pero bien alimentado!</p>
 */